import { render } from "./SideNav.vue?vue&type=template&id=17ec3038&scoped=true"
import script from "./SideNav.vue?vue&type=script&lang=js"
export * from "./SideNav.vue?vue&type=script&lang=js"

import "./SideNav.vue?vue&type=style&index=0&id=17ec3038&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-17ec3038"]])

export default __exports__